/* KASTOR — single source of truth for copy-level settings.
   PRICES ARE NOT SET HERE. Every customer-facing price comes from Shopify
   (Markets / presentment currency):
     - pack totals: window.KASTOR_SHOP.variants[].price (presentment cents)
     - formatting:  window.KASTOR_LOCALE.sample, i.e. Shopify's own `money`
                    filter output for 1234.56 in the visitor's currency.
   Unit prices and savings are derived from those presentment prices, never
   converted from another currency.                                          */
window.KASTOR_DATA = {

  reviews: { count: 214, rating: 4.7, sources: '' },

  /* qty = pack number = variant position (1, 2, 3 in Shopify). rollers = rollers received
     (free ones are inside the variant: 2+1 Free = 3 rollers, 3+2 Free = 5 rollers). */
  packs: [
    { qty: 1, rollers: 1, label: '1 Roller',          sub: '1 roller' },
    { qty: 2, rollers: 3, label: 'Buy 2, get 1 free', sub: '3 rollers', popular: true },
    { qty: 3, rollers: 5, label: 'Buy 3, get 2 free', sub: '5 rollers', best: true }
  ],

  /* 4 + 1: at `threshold` PAID rollers the zero-price reward variant
     (section setting "Free roller product") is added by kastor-cart.js.      */
  /* OFF: no script adds free products. The free rollers are part of the 2+1 / 3+2 variants. */
  reward: { enabled: false, threshold: 0, freeQty: 0, variantId: '', label: '' },

  /* dailyTimer: live countdown to 00:00 in `timezone` (store time), resets every midnight.
     Only honest if the offer really changes/ends at midnight (see LEES DIT EERST). */
  offer: { enabled: true, label: 'Glow offer', code: 'GLOW10', percent: 10, dailyTimer: true, timezone: 'Europe/Amsterdam', campaignEnd: '2026-12-31T23:59:59+01:00' },

  stock: { count: null, label: '' },

  policy: { freeShippingAll: true, returnDays: 14 },

  product: {
    name: 'Kastor Castor Oil Roller',
    volume: '30 ml',
    claims: ['100% organic castor oil', 'Cold-pressed', 'Hexane-free'],
    inci: 'Ricinus communis seed oil'
  }
};

(function (d) {
  /* ---- money: learn the format from Shopify's own output ---------------- */
  var fmt = null;
  function learn() {
    var L = window.KASTOR_LOCALE || {}, s = L.sample;
    if (!s) return null;
    try { var t = document.createElement('textarea'); t.innerHTML = String(s).replace(/<[^>]*>/g, ''); s = t.value; } catch (e) {}
    var m = s.match(/^([^\d]*)1([^\d]?)23([45])(?:([^\d])(\d\d))?([^\d]*)$/);
    if (!m) return { intl: L.currency || '' };
    return { pre: m[1], thou: m[2], dec: m[5] ? m[4] : null, suf: m[6] };
  }
  d.moneyCents = function (cents) {
    if (!fmt) fmt = learn();
    var n = Math.round(Number(cents) || 0), neg = n < 0; n = Math.abs(n);
    if (fmt && !fmt.intl) {
      var whole = fmt.dec ? Math.floor(n / 100) : Math.round(n / 100);
      var out = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thou) + (fmt.dec ? fmt.dec + String(n % 100).padStart(2, '0') : '');
      return (neg ? '\u2212' : '') + fmt.pre + out + fmt.suf;
    }
    var cur = (fmt && fmt.intl) || (window.KASTOR_CART && window.KASTOR_CART.currency) || '';
    if (cur) try { return (neg ? '\u2212' : '') + new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(n / 100); } catch (e) {}
    return (neg ? '\u2212' : '') + (n / 100).toFixed(2);
  };
  /* major-unit wrapper; name kept so existing section code keeps working */
  d.money = d.euro = function (major) { return d.moneyCents(Math.round((Number(major) || 0) * 100)); };

  /* ---- packs: presentment prices from Shopify ---------------------------- */
  function derive() {
    var base = d.packs[0].cents || 0;
    d.packs.forEach(function (p) {
      var c = p.cents || 0;
      var n = p.rollers || p.qty;
      p.unitCents = Math.round(c / n);
      p.saveCents = Math.max(0, base * n - c);
      p.total = c / 100; p.unit = p.unitCents / 100; p.save = p.saveCents / 100;
    });
  }
  d.syncPacks = function () {
    var vs = (window.KASTOR_SHOP && window.KASTOR_SHOP.variants) || [];
    d.packs.forEach(function (p, i) {
      var v = vs[i];
      p.cents = v && typeof v.price === 'number' ? v.price : 0;
    });
    d.pricesReady = d.packs.every(function (p) { return p.cents > 0; });
    derive();
  };
  d.syncPacks();
  /* seconds left until 00:00 in the store timezone; identical for every visitor, survives refresh */
  d.secondsToMidnight = function (now, tz) {
    var dt = new Date(now || Date.now()), h, m, s;
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: tz || 'Europe/Amsterdam', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(dt);
      var g = function (t) { return Number((parts.filter(function (p) { return p.type === t; })[0] || {}).value || 0); };
      h = g('hour') % 24; m = g('minute'); s = g('second');
    } catch (e) { h = dt.getHours(); m = dt.getMinutes(); s = dt.getSeconds(); }
    var left = 86400 - (h * 3600 + m * 60 + s);
    return left <= 0 || left >= 86400 ? 86399 : left;
  };
  d.clock = function (sec) { var p = function (n) { return String(n).padStart(2, '0'); }; return p(Math.floor(sec / 3600)) + ':' + p(Math.floor(sec % 3600 / 60)) + ':' + p(sec % 60); };
  d.ratingPct = (d.reviews.rating / 5) * 100;
})(window.KASTOR_DATA);
